module.exports = __webpack_public_path__ + "static/img/peitu3.6d53f25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/finance/peitu3.png
// module id = 534
// module chunks = 12